export type QuoteStatus = 'pending' | 'accepted' | 'rejected'

const statusStyles: Record<QuoteStatus, string> = {
  pending: 'bg-gray-100 text-gray-800 dark:bg-gray-800 dark:text-gray-200',
  accepted: 'bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-200',
  rejected: 'bg-red-100 text-red-800 dark:bg-red-900 dark:text-red-200',
}

const statusLabels: Record<QuoteStatus, string> = {
  pending: 'Pendiente',
  accepted: 'Aceptada',
  rejected: 'Rechazada',
}

export default function QuoteStatusBadge({ status }: { status: string }) {
  const key = (status as QuoteStatus) in statusStyles ? (status as QuoteStatus) : null
  return (
    <span
      className={`px-2 py-1 inline-flex text-xs leading-5 font-semibold rounded-full whitespace-nowrap ${
        key ? statusStyles[key] : 'bg-gray-100 text-gray-800 dark:bg-gray-800 dark:text-gray-200'
      }`}
    >
      {key ? statusLabels[key] : status}
    </span>
  )
}
